import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import messages from '../messages';
import { SignUpContainer, SignUpLink, SignUpTitleSection } from './SignupStyles';

const InstructionStepContainer = styled.ul`
  margin: 12px 0 0;
  list-style: none;
  padding-left: 0;
`;

const InstructionStepItem = styled.li`
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 24px;
`;

const instructionSteps = [
  messages.accountInstructionStep1,
  messages.accountInstructionStep2,
  messages.accountInstructionStep3,
];

const SignupInstruction = () => {
  return (
    <SignUpContainer>
      <SignUpTitleSection>
        <FormattedMessage {...messages.accountInstruction} />
      </SignUpTitleSection>

      <InstructionStepContainer>
        {instructionSteps.map((message, index) => (
          <InstructionStepItem key={message}>
            {index + 1}. <FormattedMessage {...message} />{' '}
            {!index && (
              <SignUpLink href={`${process.env.APP_WMS_URL}/customers?tab=requested-customer`}>WMS</SignUpLink>
            )}
          </InstructionStepItem>
        ))}
      </InstructionStepContainer>
    </SignUpContainer>
  );
};

export default SignupInstruction;
